import styled from 'styled-components';

// I cant figure out why playbook-web-core Text component does not work

export const Container = styled.div`
  background-color: white;
  padding: 10px;
  border-radius: 5px;
`;

export const Title = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: #192c47;
  font-family: 'Roboto';
  text-align: left;
  margin-bottom: 5px;
`;

export const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #192c47;
  font-family: 'Roboto';
  text-align: left;
  word-break: break-word;
`;
